import { defineBlock, BlockWrapper, smartProps, useChildrenBlocks } from '@smartfire/js-block-engine';
import { EditableHeading } from '@smartfire/components';
import { useMediaQuery } from '@mui/material';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import ArrowLeft from '../assets/icons/arrow_carrousel_left';
import ArrowRight from '../assets/icons/arrow_carrousel_right';
import clsx from 'clsx';

import 'swiper/css';
import style from './style.module.scss';

function Block() {
    const isMobile = useMediaQuery('(max-width: ' + style.mobileBreakpoint + ')');
    const { Child, Children, children } = useChildrenBlocks();

    const swiperProps = {
        spaceBetween: 40,
        slidesPerView: 1,
        className: style.swiper,
        autoplay: { delay: 3000, pauseOnMouseEnter: true },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
            disabledClass: style.disabled,
            hiddenClass: style.disabled,
        },
        modules: [Autoplay, Navigation],
    };

    return (
        <BlockWrapper.Div className={style.block}>
            <EditableHeading smartProp="title" className={style.title} placeholder="À propos" />
            {isMobile ? (
                <div className={style.carrousel}>
                    <ArrowLeft className={clsx(style.prev, 'swiper-button-prev')} />
                    <Swiper {...swiperProps}>
                        {children.length &&
                            children.map((_, i) => (
                                <SwiperSlide className={style.slide} key={i}>
                                    <Child index={i} />
                                </SwiperSlide>
                            ))}
                    </Swiper>
                    <ArrowRight className={clsx(style.next, 'swiper-button-next')} />
                </div>
            ) : (
                <Children
                    className={style.list}
                    gutenbergEditorConfig={{
                        orientation: 'horizontal',
                        allowedBlocks: ['smartfire/home-menu---tile'],
                    }}
                />
            )}
        </BlockWrapper.Div>
    );
}

export default defineBlock({
    Block,
    smartProps: {
        title: smartProps.object.withDefault({
            headingLevel: 2,
            content: 'À propos',
        }),
    },
    setup: {
        title: 'Home menu',
    },
});
